export const loginMessage = 'Log in to Skipply'
export const apiUrl = process.env.REACT_APP_BACKEND_API
export const loginType = 'email'
export const PROJECT_NAME = 'skipply-admin'

export const loginOperationId = (type) => {
  let operationId = 'createSessionByEmail'

  if (type === 'wallet') {
    operationId = 'createSessionByWallet'
  }

  if (type === '2fa') {
    operationId = 'createSessionByAttemptToken'
  }

  return operationId
}

export const languages = [
  { id: 'eng', label: 'English' },
  { id: 'ukr', label: 'Ukrainian' },
  { id: 'rus', label: 'Russian' },
]

export const questionTypes = [
  { id: 'radioButton', name: 'radioButton' },
  { id: 'dropdown', name: 'dropdown' },
  { id: 'checkbox', name: 'checkbox' },
  { id: 'stringMatch', name: 'stringMatch' },
  { id: 'freeString', name: 'freeString' },
  { id: 'number', name: 'number' },
  { id: 'boolean', name: 'boolean' },
]